module.exports = __webpack_public_path__ + "eb3be364f4870d574be35ad83e1be820.svg";